import styled from "styled-components/macro";

export default styled.div`
  max-width: 1300px;
  margin: 0 auto;
`;
